export const WIDGET_HEADER = 'Our Disco Widget Drives Listens';

export const WIDGET_DESCRIPTION =
  'Our widget combines eye-catching audiograms with the power of relevant recommendations to get your podcast in front of website visitors at the right time, right place.';
